export const ITEM_ROW_BORDER = 'border-2 border-transparent';

export const ITEM_ROW_SEPARATOR =
  'after:absolute after:right-0 after:bottom-0 after:left-0 after:h-px after:bg-neutral/20';

export const ITEM_ROW_FOCUS_WITHIN =
  'focus-within:rounded-lg focus-within:border-primary focus-within:ring-2 focus-within:ring-primary/10';

export const ITEM_ROW_GROUP_FOCUS_WITHIN =
  'group-focus-within:rounded-lg group-focus-within:border-primary group-focus-within:ring-2 group-focus-within:ring-primary/10';

export const GRID_COLS_PRICING =
  'grid-cols-[2fr_1fr_1fr_1fr_1fr_0.7fr_1fr_var(--size-input)_var(--size-input)_var(--size-input)]';

export const GRID_COLS_DEFAULT =
  'grid-cols-[2fr_1fr_1fr_1fr_var(--size-input)_var(--size-input)_var(--size-input)]';

export const ITEM_ROW_GRID_BASE =
  'w-full auto-rows-[2.75rem] gap-3 py-2 transition-all grid-cols-1 items-stretch';

export const ITEM_ROW_ERROR_BORDER =
  'ring-failure/60 ring-3 border-failure/20 rounded-md';

export const getItemRowGridCols = (showPricing: boolean) =>
  showPricing ? GRID_COLS_PRICING : GRID_COLS_DEFAULT;
